import * as React from 'react';
import {Customer} from 'src/domain/model/customer';
import {AuthWrapper} from '../../auth/share/auth_share_components';
import CustomerTutorialMain from './main/customer_tutorial_main';

interface IProps {
    customer: Customer | null;
    handleNextStep: () => void;
}

export const CustomerTutorialComponent: React.FC<IProps> = (props) => {

    const {
        customer, 
        handleNextStep,
        } = props;

    let res: JSX.Element;

    res = (
        <React.Fragment>
            <AuthWrapper>
                <CustomerTutorialMain
                    customer={customer}
                    handleNextStep={handleNextStep}
                />
            </AuthWrapper>
        </React.Fragment>
    );

    return (res)

};

export default CustomerTutorialComponent;


// WEBPACK FOOTER //
// ./src/presentation/component/customer/tutorial/customer_tutorial.tsx